import { ROUTE_NAMES } from './routeNames.const'

export const routeAdvisorSituation = {
  path: '/advisor-situation/',
  name: ROUTE_NAMES.advisorSituation,
  component: () =>
    import(
      /* webpackChunkName: "AdvisorSituation" */ 'src/pages/AdvisorSituation/AdvisorSituation.vue'
    ),
}
